import { concatMap, map } from "rxjs";
import { UserToken } from "../../../model/User/UserToken";
import generateSecureToken from "../../../utils/generateSecureToken";
import { apiService } from "../../ApiService";

export type PartnerSubscribeUserOptions = {
  account: PartnerCreateAccountOption;
  subscription: PartnerCreateSubscriptionOption;
  attribution?: Record<string, string>;
  isCRM?: boolean;
};
export interface PartnerCreateAccountOption {
  email?: string;
  password?: string;
  lastName?: string;
  firstName?: string;
  organization: string;
  newsletter?: boolean;
  otp?: string;
  msisdn?: string;
  method: "signup" | "signin";
  sso?: Partial<Record<"googleplayCode" | "amazonAccessToken", string>>;
  sessionID?: string;
}
export interface PartnerCreateSubscriptionOption {
  organization: string;
  redemptionCode: string;
}
export const partnerSubscribe = ({
  account,
  subscription,
  attribution,
  isCRM = false,
}: PartnerSubscribeUserOptions) => {
  return generateSecureToken(apiService.userAgent).pipe(
    concatMap((secureToken) => {
      return apiService
        .post<UserToken>({
          path: `${isCRM ? "public" : "v1"}/partner/subscribe`,
          body: {
            account,
            subscription,
            attribution,
          },
          secureToken,
          crm: isCRM,
        })
        .pipe(
          map((token) => {
            apiService.familyToken = token.familyToken;
            apiService.userToken = token.userToken;
            return token;
          }),
        );
    }),
  );
};
